import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-100 text-center text-sm text-gray-600 py-4 border-t border-gray-300">
      <div className="flex justify-center space-x-4 flex-wrap">
        <Link to="/privacy" className="hover:underline">
          Privacy Policy
        </Link>
        <span>|</span>
        <Link to="/disclaimer" className="hover:underline">
          Affiliate Disclosure
        </Link>
        <span>|</span>
        <Link to="/disclaimers" className="hover:underline">
          Disclaimers
        </Link>
        <span>|</span>
        <Link to="/contact" className="hover:underline">
          Contact
        </Link>
      </div>
      <div className="mt-2 text-xs text-gray-400">
        © {new Date().getFullYear()} YMMV-DEALS. All rights reserved.
      </div>
    </footer>
  );
}
